import { useSelector, shallowEqual } from 'react-redux';
import { selectIsLoading } from 'state/azure-active-directory/aad-slice';
import { RedirectComponent } from 'components/app/routes/RedirectComponent';
import { usePartner } from 'components/app/routes/usePartner';

export const AuthResponse = () => {
  const { partnerPath } = usePartner();
  const redirectPath = partnerPath;
  const isLoadingAuth = useSelector(selectIsLoading, shallowEqual);

  return isLoadingAuth ? null : <RedirectComponent path={redirectPath} />;
};

export default AuthResponse;
